export const CONTRACT_TABLE_FILTERS_CRITERIA_KEYS = {
  contractNumber: 'contractNumber',
  companyName: 'companyName',
  status: 'status',
  counter: 'counter',
  serviceType: 'serviceType',
  startDate: 'startDate',
  dueDate: 'dueDate',
} as const;

export const CONTRACT_TABLE_FILTERS_CRITERIA_VALUES = {
  contractNumber: 'Номер договора',
  companyName: 'Заказчик',
  status: 'Статус',
  counter: 'Порядковый номер договора',
  serviceType: 'Вид работ',
  startDate: 'Дата заключения',
  dueDate: 'Дата окончания',
} as const;

export const CONTRACT_TABLE_FILTERS_CRITERIA = [
  {
    value: CONTRACT_TABLE_FILTERS_CRITERIA_KEYS.contractNumber,
    label: CONTRACT_TABLE_FILTERS_CRITERIA_VALUES.contractNumber,
  },
  {value: CONTRACT_TABLE_FILTERS_CRITERIA_KEYS.companyName, label: CONTRACT_TABLE_FILTERS_CRITERIA_VALUES.companyName},
  {value: CONTRACT_TABLE_FILTERS_CRITERIA_KEYS.status, label: CONTRACT_TABLE_FILTERS_CRITERIA_VALUES.status},
  {value: CONTRACT_TABLE_FILTERS_CRITERIA_KEYS.counter, label: CONTRACT_TABLE_FILTERS_CRITERIA_VALUES.counter},
  {value: CONTRACT_TABLE_FILTERS_CRITERIA_KEYS.serviceType, label: CONTRACT_TABLE_FILTERS_CRITERIA_VALUES.serviceType},
  {value: CONTRACT_TABLE_FILTERS_CRITERIA_KEYS.startDate, label: CONTRACT_TABLE_FILTERS_CRITERIA_VALUES.startDate},
  {value: CONTRACT_TABLE_FILTERS_CRITERIA_KEYS.dueDate, label: CONTRACT_TABLE_FILTERS_CRITERIA_VALUES.dueDate},
] as const;

export const CONTRACT_TABLE_FILTERS_STATUSES = [
  {value: 'CREATED', label: 'Создан'},
  {value: 'DONE', label: 'Завершён'},
] as const;

export const CONTRACT_TABLE_FILTERS_STATUSES_MAP = {
  CREATED: 'Создан',
  DONE: 'Завершён',
} as const;
